import React from 'react'
import { Button, Form, ModalBody, ModalFooter, Col, Input } from 'reactstrap';
import { ModalButtonCancel, ModalButtonDelete } from '../../constant';
import { AlertTriangle } from "react-feather";


export const DeleteAgreement = (props) => {

    const { toggle, loading, name_company, saveDelete, confirmationDelete, isDelete, valueCode, setValueCode } = props;

    return (
        <>
            <>
                {
                    isDelete && (
                        <Col sm="12" className='p-l-0 p-r-0 pt-3'>
                            <div
                                style={{
                                    color: "#856404",
                                    fontSize: "0.78rem",
                                    marginTop: "6px",
                                    fontWeight: "500",
                                    backgroundColor: "#fff3cd",
                                    padding: "4px 10px",
                                    borderRadius: "6px",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    border: "1px solid #ffeeba",
                                }}
                            >
                                <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                                Una vez que confirmes el codigo del convenio, será eliminado.
                            </div> <br />
                            <Input
                                type="text"
                                className="input-admision"
                                style={{ width: "100%" }}
                                value={valueCode}
                                onChange={(e) => setValueCode(e.target.value)}
                                placeholder="Ingrese el código"
                            />
                        </Col>
                    )
                }

                {
                    !isDelete && <>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "15px",
                            marginBottom: "15px"
                        }}
                            className='pt-3'
                        >
                            <div style={{
                                backgroundColor: "#ffe6e6",
                                borderRadius: "50%",
                                width: "80px",
                                height: "48px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <AlertTriangle size={28} color="#c92a2a" />
                            </div>

                            <div>
                                {/* <h6 style={{ margin: 0, fontWeight: 600, color: "#0d3b59" }}>
                                                ¿Eliminar este médico?
                                            </h6> */}
                                <p
                                    className="mb-0"
                                    style={{
                                        fontSize: "13px",
                                        color: "#0d3b59"
                                    }}
                                >
                                    Esta acción no se puede deshacer. ¿Estás seguro de eliminar el convenio?
                                </p>

                            </div>
                        </div>

                        <div style={{
                            background: "#f8fbff",
                            padding: "12px 14px",
                            borderRadius: "8px",
                            border: "1px solid #d7e7f5"
                        }}>
                            <span style={{ fontWeight: 500, color: "#0d3b59" }}>
                                {name_company}
                            </span>
                        </div>
                        <br />
                    </>
                }
            </>

        </>
    )
}
